import React, { lazy } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import LoginContainer from './login/container/LoginContainer'

// Development Components (no authentication required)
const InternalTabStandalone = lazy(() => import('./budget/components/InternalTabStandalone'))

interface Props {
  loggedIn: boolean | undefined
  pubPath: string
}

const PublicRoutes = (props: Props): JSX.Element => {
  return (
    <Switch>
      <Route path='/login' component={LoginContainer} />
      {/* Development route for testing InternalTab */}
      <Route path='/dev/internal-tab' component={InternalTabStandalone} />
      {/* Password reset routes must come BEFORE the redirect to ensure they're matched */}
      <Route
        path='/password-reset/:uid/:token'
        component={LoginContainer}
      />
      {/* Only redirect to login/home if not on a password reset URL */}
      {props.loggedIn ? <Redirect to='/' /> : props.pubPath === '/login' ? <Redirect to='/login' /> : null}
    </Switch>
  )
}

export default PublicRoutes
